import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardTable from '../../microservice/components/CardTable';
import config from '../../microservice/components/config-en';
import Sidebar from '../../container/Sidebar/Sidebar';
import '../../Style/defaultstyle.css';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function LongRunningENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Long-Running")} */}

                        <BoxContent>
                            <BoxText >
                                <p class="typo-14">If an API method in the client application takes a long time, it can be run asynchronously in the background on the server,</p>
                                <p class="typo-14">the client then transitions to the next screen or proceeds with the next step in the code,</p>
                                <p class="typo-14">the system can be designed to return the completion status of the background task.</p><br></br>
                                <p class="typo-14">By using long-running operations, the client receives asynchronous, real-time responses indicating whether the operation has completed or encountered an error.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {CardTable(
                            "<p class='typo-21 typo-medium typo-black'>Long-running refers to an Asynchronous Request-Reply pattern — a background execution process that operates asynchronously.</p>", config.tb7_header, config.tb7_content)}

                        <DividerComponent />
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Long-running operation flow</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/long-running/long-running-1.svg"></ImageWrap>
                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px; 
    margin-bottom: 20px;
    margin-top: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    ${'' /* margin: 5px; */}
    line-height: 2em;
`
const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default LongRunningENG;